import { ReactNode } from 'react'

import ChevronRightIcon from '@/assets/icons/chevron-right.svg?react'
import { cn } from '@/utils/style'

interface KpiCardProps {
  label: ReactNode
  value: ReactNode
  onClick?: () => void
}

export function KpiCard({ label, value, onClick }: KpiCardProps) {
  return (
    <div
      className={cn(
        'ring-1 ring-neutral-200 rounded-xl p-4 flex items-center justify-between gap-2',
        onClick && 'cursor-pointer hover:bg-panel-gray-100',
      )}
      onClick={onClick}
    >
      <div className="flex flex-col gap-2 min-w-0">
        <div className="t-sm text-secondary">{label}</div>
        <div className="h5 text-primary truncate">{value}</div>
      </div>
      {onClick && <ChevronRightIcon className="w-4 h-4 text-tertiary flex-shrink-0" />}
    </div>
  )
}
